export default [
    //合同列表
    {
        path: '/anlyDashboard/invoice',
        component: require('@/views/AnlyDashboard/Invoice/Index').default
    },
    // 机构流失率
    {
        path: "/anlyDashboard/organizationLossRate",
        component: require('@/views/AnlyDashboard/LossRate/Index').default
    },
    //统计数据
    {
        path: '/anlyDashboard/directData',
        component: require('@/views/AnlyDashboard/DirectData/Index').default,
    },
    //同学科续班列表
    {
        path: '/anlyDashboard/subjectRenewal',
        component: require('@/views/AnlyDashboard/SubjectRenewal/Index').default,
    },
    //学生续班列表
    {
        path: '/anlyDashboard/StudentRenewal',
        component: require('@/views/AnlyDashboard/StudentRenewal/Index').default,
    },
    //班主任续班列表
    {
        path: '/anlyDashboard/headTeacherRenewal',
        component: require('@/views/AnlyDashboard/HeadTeacherRenewal/Index').default,
    },
    //机构续班列表
    {
        path: '/anlyDashboard/organizationRenewal',
        component: require('@/views/AnlyDashboard/OrganizationRenewal/Index').default,
    },
    //回访一周数据
    {
        path: '/anlyDashboard/returnVisitWeek',
        component: require('@/views/AnlyDashboard/ReturnVisitWeek/Index').default,
    },
    //余课学生数据
    {
        path: '/anlyDashboard/crunkStudent',
        component: require('@/views/AnlyDashboard/CrunkStudent/Index').default,
    },
    //财务-合同数据
    {
        path: '/anlyDashboard/financialInvoice',
        component: require('@/views/AnlyDashboard/FinancialInvoice/Index').default,
    },
    //财务-班级数据
    {
        path: '/anlyDashboard/financialClass',
        component: require('@/views/AnlyDashboard/FinancialClass/Index').default,
    },
    //财务-商店数据
    {
        path: '/anlyDashboard/financialShop',
        component: require('@/views/AnlyDashboard/FinancialShop/Index').default,
    },
    //各时段学生数据
    {
        path: '/anlyDashboard/templateTimeStudent',
        component: require('@/views/AnlyDashboard/TemplateTimeStudent/Index').default,
    },
    //每日学生数据
    {
        path: '/anlyDashboard/dailyStudent',
        component: require('@/views/AnlyDashboard/DailyStudent/Index').default,
    },
    //每日学生数据
    {
        path: '/anlyDashboard/newHeadTeacherRenewal',
        component: require('@/views/AnlyDashboard/NewHeadTeacherRenewal/Index').default,
    },
    //每日学生数据
    {
        path: '/anlyDashboard/continueToClassRenewal',
        component: require('@/views/AnlyDashboard/ContinueToClassRenewal/Index').default,
    },
    //学生数据
    {
        path: '/anlyDashboard/semesterStudentRenewal',
        component: require('@/views/AnlyDashboard/SemesterStudent/Index').default,
    },
    //优惠券使用数据
    {
        path: '/anlyDashboard/discountTypeRenewal',
        component: require('@/views/AnlyDashboard/DiscountTypeRenewal/Index').default,
    },
    //教师工作量数据
    {
        path: '/anlyDashboard/teacherWorkloadRenewal',
        component: require('@/views/AnlyDashboard/TeacherWorkload/Index').default,
    },
    //网络课数据
    {
        path: '/anlyDashboard/onlineStudentClassHour',
        component: require('@/views/AnlyDashboard/OnlineStudentClassHour/Index').default,
    },
    //收费追踪数据
    {
        path: '/anlyDashboard/CartTrackingRenewal',
        component: require('@/views/AnlyDashboard/CartTrackingRenewal/Index').default,
    },
]

